<template>
    <div class="skill-rating">
        <SkillRatingSymbol :filled="!!rating && rating >= 1" :class="{'skill-rating__editable': inEditMode}" @click="changeRating(1)" />
        <SkillRatingSymbol
            :filled="!!rating && rating >= 2"
            :class="{'skill-rating__editable': inEditMode}"
            class="skill-rating__center"
            @click="changeRating(2)"
        />
        <SkillRatingSymbol :filled="!!rating && rating >= 3" :class="{'skill-rating__editable': inEditMode}" @click="changeRating(3)" />
    </div>
</template>

<script setup lang="ts">
    import type {PropType} from 'vue';
    import {storeToRefs} from 'pinia';
    import SkillRatingSymbol from '~/components/admin-section-tabs/qualification/SkillRatingSymbol.vue';
    import {useProfileQualificationStore} from '~/store/profileQualificationStore';

    const props = defineProps({
        rating: {
            type: Number as PropType<number | null>,
            default: null,
            required: false,
        },
    });
    const emit = defineEmits(['update:rating']);

    const profileQualificationStore = useProfileQualificationStore();
    const {inEditMode} = storeToRefs(profileQualificationStore);

    function changeRating(rating: number) {
        if (!(inEditMode && inEditMode.value === true)) {
            return;
        }
        if (props.rating === rating) {
            if (props.rating > 1) {
                emit('update:rating', props.rating - 1);
            } else {
                emit('update:rating', null);
            }
        } else {
            emit('update:rating', rating);
        }
    }
</script>

<style lang="scss" scoped>
    .skill-rating {
        display: flex;
        align-items: center;

        &__center {
            margin: 0px 5px;
        }

        &__editable:hover {
            height: 6px;
            cursor: pointer;
            border: 1px solid #c8c8c8;
        }
    }
</style>
